import Router from 'next/router'
import React from 'react'

import { PREVENT_ROUTE_CHANGE_ERROR } from 'lib/constants'

export const usePreventRouteChange = (isPrevented: boolean, onRerouteAttempt: () => void) => {
	const [stashedNextRoute, setStashedNextRoute] = React.useState<string | null>(null)

	const handleBeforeRouteChange = React.useCallback(
		(url: string) => {
			if (Router.pathname !== url) {
				onRerouteAttempt()
				setStashedNextRoute(url)
				Router.events.emit('routeChangeError')
				throw PREVENT_ROUTE_CHANGE_ERROR
			}
		},
		[onRerouteAttempt],
	)

	const continueRouteChange = React.useCallback(() => {
		if (!stashedNextRoute) {
			return
		}
		Router.events.off('routeChangeStart', handleBeforeRouteChange)
		Router.push(stashedNextRoute)
		setStashedNextRoute(null)
	}, [handleBeforeRouteChange, stashedNextRoute])

	React.useEffect(() => {
		if (!isPrevented) {
			return
		}

		Router.events.on('routeChangeStart', handleBeforeRouteChange)

		return () => {
			Router.events.off('routeChangeStart', handleBeforeRouteChange)
		}
	}, [handleBeforeRouteChange, isPrevented])

	return { continueRouteChange }
}
